export default "__VITE_ASSET__DCfDHNC4__"